/*
 * @Description: 案例审核全文模式
 * @Author: hanpengtao
 * @Date: 2022-04-26 09:12:01
 */
import React, { useState, useEffect, useRef } from 'react';
import { message, Upload ,Button} from 'antd';
import { UploadToOss } from '../../../../util/uploadTool';
import classnames from 'classnames';
import AliUploader from '@/component/AliUploader/linggan_aliupload';
// 富文本编辑器引入插件库以及样式----------------
import BraftEditor from 'braft-editor';
import { ContentUtils } from 'braft-utils';
import 'braft-editor/dist/index.css';
import './index.less';

// 富文本插入图片所需常量
const dirname = 'caseManage/'
const imgPrefix =
  'https://qingtu-image-originals.oss-cn-shanghai.aliyuncs.com/'
const token = {
  host: 'https://image.znzgo.com/',
  ALI_HOST: imgPrefix,
  // access_key_id: 'LTAI5t8ubGymdJDnqyAe2EM2', // oss的key_id
  // access_key_secret: 'zfkvIN3eft7FrYJqfCRDURjGxhSHcF', // oss的secret
  OSS_ENDPOINT: 'oss-cn-shanghai.aliyuncs.com', // 自己oss服务器的配置信息
  OSS_BUCKET: 'qingtu-image-originals', // 自己oss服务器的配置信息
  OSS_REGION: 'oss-cn-shanghai',
}

const TextMode = (props) => {
  const { caseData, onTextChange, wrapClassName, type } = props;

  //默认插入img展示的话必须带有div标签 否则无法编辑切记
  const [editorState, setEditorState] = useState(BraftEditor.createEditorState(''));

  useEffect(() => {
    handleCaseContentList(type === 'text'? caseData?.contents : caseData?.caseContent
    );
  }, [caseData?.contents,caseData?.caseContent]);

  const handleChange = (editorState) => {
    setEditorState(editorState);
    const html = toHtml(editorState);
    onTextChange(html);
  }

  const toHtml = (editor) => {
    return editor.toHTML().replaceAll("<p></p>", "").replaceAll("<div></div>", "").replaceAll('<div class="media-wrap image-wrap">', "<p>").replaceAll('</div>', "</p>");
  }

  // 处理富文本默认显示内容
  const handleCaseContentList = (caseContentList) => {
    let showEditorCnt = '';
    let saveFirstCnt = "";
    if (caseContentList?.length > 0) {
      caseContentList.forEach(item => {
        if(type === 'translate'){
          if (item.type == 0) {
            showEditorCnt += '<div><img src="' + item.imgUrl + '"/></div>'
            saveFirstCnt += '<img src="' + item.imgUrl + '"/>'
          } else {
              showEditorCnt += '<p>' + item.textTranslated+ '</p>'
              saveFirstCnt += '<p>' + item.textTranslated+ '</p>'
          }
        }else{
          if (item.textOriginCss && item.textOriginCss != '') {
            if (item.textOriginCss.indexOf("img") != -1) {
              showEditorCnt += '<div>' + item.textOriginCss.replaceAll('class="media-wrap image-wrap"', "") + '</div>'
            } else {
              showEditorCnt += item.textOriginCss
            }
            saveFirstCnt += item.textOriginCss
          } else {
            if (item.type == 0) {
              showEditorCnt += '<div><img src="' + item.imgUrl + '"/></div>'
              saveFirstCnt += '<img src="' + item.imgUrl + '"/>'
            } else {
                showEditorCnt += '<p>' + item.textOrigin + '</p>'
                saveFirstCnt += '<p>' + item.textOrigin + '</p>'
            }
          }
        }

      });
      const initState = BraftEditor.createEditorState(showEditorCnt);
      setEditorState(initState);
      onTextChange(toHtml(initState));
    } else {
      setEditorState(BraftEditor.createEditorState(''));
    }
  }

  // 其他按钮的上传功能上传功能
  // mediaType: 0 - 插入图片
  // mediaType: 1 - 插入
  // buttonType 0 - 软件介绍、1 - 安装教程、2 - 使用教程
  // const otherUpload = (info, uploaded_object_name) => {
  //   // console.log(info)
  //   if (info.status == 200) {
  //     // 采用token.host 作为cdn地址这样比oss流量便宜
  //     const url = `${token.host}${uploaded_object_name}`
  //     let result = null;
  //     result = ContentUtils.insertMedias(editorState, [{
  //       type: 'IMAGE',
  //       url,
  //     }]);
  //     setEditorState(result);
  //     message.success('上传成功！')
  //   } else {
  //     message.error('上传失败！')
  //   }
  // }

  const beforeUpload = (file) => {
    const img_type = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
    const img_size = file.size / 1024 / 1024;
    if (!img_type.includes(file.type)) {
      return false;
    }
    if (img_size > 50) {
      return false;
    }

    let reader = new FileReader();
    reader.readAsDataURL(file);
    const OssToken = token;
    reader.onloadend = async () => {
      // 使用ossupload覆盖默认的上传方法
      message.loading('上传中');
      UploadToOss({ token: OssToken }, OssToken.ALI_HOST, file)
        .then((data) => {
          let url = OssToken.host + data.name;
          let result = null;
          result = ContentUtils.insertMedias(editorState, [{
            type: 'IMAGE',
            url,
          }]);
          setEditorState(result);
          onTextChange(toHtml(result));
          message.success('上传成功！')
        })
        .catch((err) => {
          message.destroy();
          message.error('上传失败，请重试~');
        })
        .finally(() => {
          message.destroy();
        });
    };

    return false;
  };
  return (
    <div className={classnames('textMode', wrapClassName)}>
      <BraftEditor
        
        contentStyle={{ height: 630 }}
        value={editorState}
        controls={[//需求所需要的的配置
          'undo', 'redo', 'separator',
          'font-size', 'line-height', 'letter-spacing', 'separator',
          'text-color', 'bold', 'italic', 'underline', 'strike-through', 'separator',
          'separator', 'text-indent', 'text-align', 'separator',
          'separator', 'separator', 'clear'
        ]}
        placeholder="请输入正文内容"
        readOnly={type === 'translate'}
        onChange={handleChange}
        extendControls={[
          {
            key: 'useTutorialImage_upload',
            type: 'component',
            component: (
              <div style={{paddingTop:'12px',cursor:'pointer'}}>
              <Upload
                // {...props}
                showUploadList={false}
                beforeUpload={(file) => beforeUpload(file)}
              >
                  插入图片
              </Upload>
              </div>
            )
          },
        ]
      }
      />
{/* 
      <AliUploader
        id="useTutorialImage_upload"
        dirname={dirname}
        fileUploaded={(up, file, info, uploaded_object_name) => {
          console.log(uploaded_object_name)
          otherUpload(info, uploaded_object_name)
        }}
        uploaderInit={(func) => (uploaderInit.current = func)}
        token={token}
      /> */}
    </div>
  )
}

export default TextMode;